import Vue from 'vue';
import Router from 'vue-router';
import RegisterBlocks from './views/blocks/RegisterBlocks.vue';

Vue.use(Router);

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      name: '404',
      beforeEnter() {
        window.location.href = 'https://www.omni.com.br/404';
      },
    },
    {
      path: '/',
      name: 'root',
      redirect: {
        name: 'register-blocks'
      },
    },
    {
      path: '/cadastro',
      name: 'register',
      redirect: {
        name: 'register-blocks'
      }
    },
    {
      path: '/cadastro-blocks',
      name: 'register-blocks',
      component: RegisterBlocks
    }
  ],
});
